import { render, staticRenderFns } from "./WhatsAppChat.vue?vue&type=template&id=5b27493d&scoped=true&"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js&"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppChat.vue?vue&type=style&index=0&id=5b27493d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27493d",
  null
  
)

export default component.exports